import React, { FunctionComponent, memo } from 'react'
import ReSelect, { MenuPosition } from 'react-select'

import './Select.scss'

export interface KeyValue {
  value: string
  label: string
}

interface Props {
  placeholder: string
  items: KeyValue[]
  onChange: (item: KeyValue | null) => void
  value?: string | null
  menuPosition?: MenuPosition
}

const Select: FunctionComponent<Props> = ({ placeholder, items, onChange, value }) => {
  return (
    <ReSelect
      value={items.find((item) => item.value === value)}
      className="reselect"
      classNamePrefix="reselect"
      isSearchable={false}
      options={items}
      onChange={(item) => onChange(item)}
      placeholder={placeholder}
      captureMenuScroll={false}
    />
  )
}

export default memo(Select)
